import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Container = styled.div`
box-sizing: border-box;
    margin: 15px;
    width: 95%;
    height: 50px;
    border: 1px solid #C5C5C5;
    border-radius: 7px;
    padding-top: 10px;
    display: flex;
    margin-left: 0;
    background-color:white;

`
export const CustomLink = styled(NavLink)`
&.TabActive{
    color:#4678ED;
    border-bottom: 4px solid #4678ED;
}
height: 100%;
min-width:150px;
font-size:15px;
text-align: center;
font-weight: 600;
color:#58595B;
border-bottom: ${props => props.border ? props.border : ""};
cursor: pointer;
margin-left:10px;
margin-right:10px;
text-decoration:none;
font-weight:600;
font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif;
{/*&:hover{
    color:#4678ED;
    border-bottom: 4px solid #2196F3;
}*/}
@media (max-width: 1124px) {
    min-width:125px;
  } 
@media (max-width: 906px) {
    font-size:12.5px;
    min-width:90px;
  }
@media (max-width: 656px) {
    font-size:11px;
    min-width:75px;
  }
  @media (max-width: 556px) {
    font-size:9.5px;
    min-width:65px;
  }
`